//// <reference path="./declare.d.ts" />

// Vue component imports
import SmartyStreetsCandidates from './smartyStreetsCandidates.vue'
import * as SmartyStreetsSDK from "smartystreets-javascript-sdk";
//import * as sdkUtils from "smartystreets-javascript-sdk-utils/index.js";
const sdkUtils = require("smartystreets-javascript-sdk-utils/index.js")

declare const SmartyStreetsSDK_WebsiteKey: string
declare const SmartyStreetsSDK_WebsiteKey_LicenseName: string[] //["us-standard-cloud"]

import Vue from 'vue'

//import App from './app'

/*new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
*/
// export everything

/*export {
    SSAClient, SSAConsultant, SSAGrid,SSAAdmin
}*/

/*export function install (Vue) {
  // Set defaults

    Vue.component('GnosisSsaClient', SSAClient)
    Vue.component('GnosisSsaConsultant', SSAConsultant)
    Vue.component('GnosisSsaGrid', SSAGrid)
    Vue.component('GnosisSsaAdmin', SSAAdmin)
}*/


// Import vue component

// Declare install function executed by Vue.use()
export function install(Vue: any) {
	if ((install as any).installed) return;
	(install as any).installed = true;
  Vue.component('gnosis-smartyStreetsCandidates', SmartyStreetsCandidates)
}

// Create module definition for Vue.use()
const plugin = {
	install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}


var gnosisAddressValidation = null;

const SmartyStreetsCore = SmartyStreetsSDK.core;
const smartyStreetsSharedCredentials = new SmartyStreetsCore.SharedCredentials(
    SmartyStreetsSDK_WebsiteKey
);

let usStreetClientBuilder = new SmartyStreetsCore.ClientBuilder(
    smartyStreetsSharedCredentials
)
if (SmartyStreetsSDK_WebsiteKey_LicenseName && SmartyStreetsSDK_WebsiteKey_LicenseName.length > 0) {
    usStreetClientBuilder = usStreetClientBuilder.withLicenses(SmartyStreetsSDK_WebsiteKey_LicenseName);
}




interface IAddress {
    address1: string;
    address2?: string;
    city?: string
    state?: string
    zipCode?: string
}
interface ICandidateAddress extends IAddress {
    candidateIndex: number
}
class addressValidationResult {
    error: string = '';
    isValid: boolean = false;
    isAmbiguous: boolean = false;
    isMissingSecondary: boolean = false;
    validatedAddress: IAddress | null = null;
    rawResult: object | null= null;
    candidateAddresses: IAddress[] | null = null;
}

const usStreetClient = usStreetClientBuilder.buildUsStreetApiClient();

(globalThis as any).gnosisAddressValidation = {
    validateAddress: async function (address: IAddress, maxCandidates: Number): Promise<addressValidationResult> {
        if (address === null) {
            address = { address1: "PO Box 4 Old Chelsea Station New York, NY 10011" }
        }
        let lookup = new SmartyStreetsSDK.usStreet.Lookup();
        lookup.street = address.address1;
        lookup.street2 = address.address2 || '';
        lookup.city = address.city || '';
        lookup.state = address.state || '';
        lookup.zipCode = address.zipCode || '';
        lookup.maxCandidates = parseInt(maxCandidates as any) || 10;
        if (!!lookup.street) {
            try {
                const res = await usStreetClient.send(lookup)

                const avRes = new addressValidationResult()

                const resLookup = res.lookups[0];
                avRes.rawResult = res
                avRes.isValid = sdkUtils.isValid(resLookup);
                avRes.isAmbiguous = sdkUtils.isAmbiguous(resLookup);
                avRes.isMissingSecondary = sdkUtils.isMissingSecondary(resLookup);

                if (!avRes.isValid) {
                  //  avRes.error = "The address is invalid."
                } else if (avRes.isAmbiguous) {
                    avRes.candidateAddresses = resLookup.result.map( (candidate) => { 
                        return this.rawCandidateToAddress(candidate, true) }, this)
                } else if (avRes.isMissingSecondary) {
                   //avRes.error = "The address is missing a secondary number."
                } else if (avRes.isValid) {
                    const candidate = resLookup.result[0];
                    if (address.address1 !== candidate.deliveryLine1 ||
                        address.address2 !== candidate.deliveryLine2 ||
                        address.city !== candidate.components.cityName ||
                        address.state !== candidate.components.state ||
                        address.zipCode !== candidate.components.zipCode + "-" + candidate.components.plus4Code
                    ) {

                        avRes.validatedAddress = this.rawCandidateToAddress(candidate)
                    }

                }
                else {
                    avRes.error = "Unknown Error"
                }
                return Promise.resolve(avRes)
            }
            catch (e) {
                const errRes = new addressValidationResult()
                errRes.error = (e as any).error
                return Promise.reject(errRes)
            }

        } else {
            const errRes = new addressValidationResult()
            errRes.error = "A street address is required.";
            return Promise.reject(errRes)

        }
    },
    rawCandidateToAddress: function (candidate:SmartyStreetsSDK.usStreet.Candidate, setCandidateIndex: Boolean): IAddress | ICandidateAddress {
      const add:IAddress =   {
            address1: candidate.deliveryLine1,
                address2: candidate.deliveryLine2,
                    city: candidate.components.cityName,
                        state: candidate.components.state,
                            zipCode: candidate.components.zipCode + "-" + candidate.components.plus4Code
        }

        if (setCandidateIndex) {
            const addCan: ICandidateAddress = {...add, candidateIndex: candidate.candidateIndex }
            return addCan
        }
        else {
            return add
        }

    }
}

// To allow use as module (npm/webpack/etc.) export component
export {SmartyStreetsCandidates, };